export function updatePinTypes(state, value) {
  state.pinTypes = value
}

export function updateRegions(state, value) {
  state.regions = value
}

export function updateEntities(state, value) {
  state.entities = value
}

export function updateEntityTypes(state, value) {
  state.entityTypes = value
}

export function updateEntityProfile(state, value) {
  state.entityProfile = value[0]
}

export function updateTags(state, value) {
  state.tagItems = value
}